import {
  type ProvideServicesMetadataType,
  type TaskResponseType,
  type SendPaymentMetadataType,
  type ConfirmMultipliersMetadataType,
  type DetermineShareRebateAmountMetadataType,
  type ProvideUtilityCredentialsMetadataType,
  type ProvideEquipmentCatalogDetailsMetadataType,
  type ProvideIncomeEstimateMetadataType,
  type VerifyIncomeQualificationMetadataType,
  type SubmitForPreapprovalMetadata3CRENType,
  type SubmitForMetadataHIASPType,
  type SubmitForPreapprovalMetadataCAHEEHRAType,
  type SubmitForPreapprovalMetadataWIHEARType,
  type SubmitForPreapprovalMetadataSunrunType,
  type ProvideWaterHeaterInstalledDetailsMetadataType,
  type ResolveSubmitTasksMetadataType,
  type ReviewQualityInstallReportMetadataType,
  type SubmitJobForEnrollmentSunrunMetadataType,
  type SubmitJobForEnrollmentMetadataType,
  type SubmitJobForEnrollmentWIHEARMetadataType,
  type ApplyForIncomeVerificationMetadataType,
  type ReviewManualJReportMetadataType,
  type ReviewIncomeQualificationMetadataType,
  type ProvideAdditionalIncentivesDetailsMetadataType,
  type ReviewPreHomeSafetyAssessmentMetadataType,
  type ReviewInstalledEquipmentMetadataType,
  type SubmitForPreapprovalMetadataCATECHType,
  type SubmitForPreapprovalMetadataCATECHWaterHeaterType,
  type MechanicalVentilationMetadataType,
  type CreateScopeOfWorkMetadataType,
  type SubmitJobForEnrollmentCATECHWHMetadataType,
  type GenericAttachmentsMetadataType,
  type StartIncomeQualificationMetadataGAHEARType,
  type UpdateFuelSwitchingCalculatorMetadataType,
  type SubmitForPreapprovalMetadataGAHEARType,
  type DocumentTaskMetadataType,
  type ProvideIncomeEnhancedIncentiveMetadata3CEType,
  type ReviewUtilityBillsMetadataType,
  type SubmitJobForEnrollment3CEMetadataType,
  type ApprovePaymentMetadataType,
  type SubmitJobForEnrollmentCOXcelMetadataType,
  type ProgramSubmissionsMetadataType,
  type ReviewFinalInvoiceMetadataType,
  type ReviewPermitMetadataType,
  type ReviewSignedApplicationMetadataType,
  type ReviewUploadedCommissioningFormMetadataType,
  type ConfirmManualJReportMetadataType,
  type ConfirmInstalledHeatPumpMetadataType
} from '@shared/generated';

export const isProvideServicesMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideServicesMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'attachments_installation_services' in metadata &&
    'attachments_removal_services' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewQualityInstallReportMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewQualityInstallReportMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'primary_contractor' in metadata &&
    'customer' in metadata &&
    'rebate_selection' in metadata &&
    'existing_equipment' in metadata &&
    'new_electrical_configuration' in metadata &&
    'heat_pump_water_heater_equipment' in metadata &&
    'heat_pump_equipment' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSendPaymentMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SendPaymentMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'payable_amount' in metadata &&
    'invoiced_at' in metadata &&
    'paid_at' in metadata &&
    'payment_reference' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewManualJReportMetadata = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewManualJReportMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'site_address' in metadata &&
    'square_footage' in metadata &&
    'occupants' in metadata &&
    'heat_pump_equipment' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewIncomeQualificationMetadata = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewIncomeQualificationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('proof_of_income' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isProgramSubmissionsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProgramSubmissionsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'submissions' in metadata;
};

export const isReviewSignedApplicationMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewSignedApplicationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'application' in metadata &&
    'utility_bills_electric' in metadata &&
    'utility_bills_gas' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewUtilityBillsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewUtilityBillsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('utility_bills_electric' in metadata && 'utility_bills_gas' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isProvideAdditionalIncentivesMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideAdditionalIncentivesDetailsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'additional_incentives' in metadata &&
    'additional_incentives_notes' in metadata &&
    'invoice' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewInstalledEquipmentMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewInstalledEquipmentMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'heat_pump_equipment' in metadata &&
    'heat_pump_water_heater_equipment' in metadata &&
    'other_equipment' in metadata &&
    'attachments' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isCreateScopeOfWorkMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is CreateScopeOfWorkMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('installed_equipment' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isDocumentTaskMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is DocumentTaskMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('attachment' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isConfirmMultipliersMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ConfirmMultipliersMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'county' in metadata &&
    'attachments' in metadata &&
    'english_not_primary_language' in metadata &&
    'in_disadvantaged_census_tract_3cren' in metadata &&
    'is_hard_to_reach_3cren' in metadata &&
    'error' in metadata &&
    'is_mobile_manufactured_home' in metadata &&
    'is_native_american' in metadata &&
    'on_income_qualified_rate_3cren' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isDetermineAndShareRebateAmountMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is DetermineShareRebateAmountMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'original_rebate_cents_total' in metadata &&
    'original_rebate_cents_total_payable_to_contractor' in metadata &&
    'is_hard_to_reach' in metadata &&
    'show_final_to_contractor' in metadata &&
    'sealed_estimate_energy_impact_kwh' in metadata &&
    'sealed_estimate_energy_impact_therms' in metadata &&
    'sealed_estimate_energy_impact_gallons' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isProvideEquipmentCatalogDetailsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideEquipmentCatalogDetailsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('has_heat_pump' in metadata && 'has_heat_pump_hot_water' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isProvideUtilityCredentialsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideUtilityCredentialsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'site' in metadata &&
    'site_contact' in metadata &&
    'utilities' in metadata &&
    'energy_sources' in metadata &&
    'email' in metadata &&
    'contractor_logo' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isProvideIncomeEstimateMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideIncomeEstimateMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('ami_80_cents' in metadata && 'ami_150_cents' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isProvideIncomeEnhancedEstimateMetadata3CEType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideIncomeEnhancedIncentiveMetadata3CEType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('family_size' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isVerifyIncomeQualificationMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is VerifyIncomeQualificationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    ('income_documentation_url' in metadata &&
      'income_verification_url' in metadata) ||
    ('show_sealed_support_contact' in metadata &&
      'application_link_url' in metadata &&
      'more_details_url' in metadata)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataHIASPType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForMetadataHIASPType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'customer_email' in metadata &&
    'project_name' in metadata &&
    'contractor_name' in metadata &&
    'year' in metadata &&
    'building_type' in metadata &&
    'dwelling_units' in metadata &&
    'total_project_cost' in metadata &&
    'electric_provider' in metadata &&
    'electric_said' in metadata &&
    'gas_provider' in metadata &&
    'gas_said' in metadata &&
    'proposed_scope_of_work' in metadata &&
    'pre_install_photos' in metadata &&
    'blower_door_test_photos' in metadata &&
    'rebate_assigned_to' in metadata &&
    'insulation_services' in metadata &&
    'has_air_sealing_service' in metadata &&
    'project_submission_type' in metadata &&
    'contract_sold_date' in metadata &&
    'primary_heating_fuel' in metadata &&
    'primary_heating_type' in metadata &&
    'primary_cooling_type' in metadata &&
    'hvac_system_type' in metadata &&
    'install_completion_date' in metadata &&
    'submission_type' in metadata &&
    'total_incentive' in metadata &&
    'total_energy_savings_electric_kwh' in metadata &&
    'total_energy_savings_natural_gas_therms' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataCAHEEHRAType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataCAHEEHRAType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'ami_range' in metadata &&
    'is_3ce_customer' in metadata &&
    'seeking_heehra_rebate' in metadata &&
    'proof_of_income' in metadata &&
    'previous_primary_heating_fuel' in metadata &&
    'existing_ac' in metadata &&
    'number_of_condensers' in metadata &&
    'signed_tech_terms_and_conditions' in metadata &&
    'is_equipment_energy_star_qualified' in metadata &&
    'is_new_gas_furnace_being_installed' in metadata &&
    'heating_equipment_removal_type' in metadata &&
    'has_customer_received_another_federal_funding' in metadata &&
    'income_qual_approval_code' in metadata &&
    'verify_income_qual_type' in metadata &&
    'is_caheehra_only_project' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataCATECHType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataCATECHType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'ami_range' in metadata &&
    'is_3ce_customer' in metadata &&
    'proof_of_income' in metadata &&
    'previous_primary_heating_fuel' in metadata &&
    'existing_ac' in metadata &&
    'number_of_condensers' in metadata &&
    'signed_tech_terms_and_conditions' in metadata &&
    'is_equipment_energy_star_qualified' in metadata &&
    'is_new_gas_furnace_being_installed' in metadata &&
    'heating_equipment_removal_type' in metadata &&
    'seeking_heehra_rebate' in metadata &&
    'income_qual_approval_code' in metadata &&
    'verify_income_qual_type' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataCATECHWaterHeaterType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataCATECHWaterHeaterType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'is_3ce_customer' in metadata &&
    'proof_of_income' in metadata &&
    'signed_tech_terms_and_conditions' in metadata &&
    'qualify_for_equity_incentives' in metadata &&
    'verify_income_qual_type' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreapprovalMetadataGAHEARType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataGAHEARType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'expected_completion_date' in metadata &&
    'type_of_electric_utility_provider' in metadata &&
    'electric_utility_provider' in metadata &&
    'electric_meter_number' in metadata &&
    'electric_account_number' in metadata &&
    'has_gas_utility' in metadata &&
    'type_of_gas_utility_provider' in metadata &&
    'gas_utility_provider' in metadata &&
    'gas_meter_number' in metadata &&
    'gas_account_number' in metadata &&
    'has_delivered_fuel_company' in metadata &&
    'delivered_fuel_company_name' in metadata &&
    'delivered_fuel_type' in metadata &&
    'delivered_fuel_account_number' in metadata &&
    'upgrades_include_water_heater' in metadata &&
    'existing_water_heater_fuel_type' in metadata &&
    'existing_water_heater_capacity' in metadata &&
    'new_water_heater_capacity' in metadata &&
    'water_heater_equipment' in metadata &&
    'water_heater_material_costs' in metadata &&
    'water_heater_install_costs' in metadata &&
    'water_heater_total_costs' in metadata &&
    'water_heater_pre_retrofit_attachment' in metadata &&
    'upgrades_include_heat_pump' in metadata &&
    'new_heat_pump_system_type' in metadata &&
    'existing_primary_heating_type' in metadata &&
    'existing_primary_cooling_type' in metadata &&
    'new_heat_pump_meets_energy_star_for_cold_climate' in metadata &&
    'new_heat_pump_percent_heating_load' in metadata &&
    'new_heat_pump_heating_capacity' in metadata &&
    'new_heat_pump_cooling_capacity' in metadata &&
    'heat_pump_equipment' in metadata &&
    'heat_pump_material_costs' in metadata &&
    'heat_pump_installation_costs' in metadata &&
    'heat_pump_total_costs' in metadata &&
    'heat_pump_pre_retrofit_attachment' in metadata &&
    'upgrades_involve_fuel_switching' in metadata &&
    'limited_assesment_date' in metadata &&
    'year_built' in metadata &&
    'is_ceiling_insulation_r_value_known' in metadata &&
    'ceiling_insulation_r_value' in metadata &&
    'ceiling_insulation_type' in metadata &&
    'are_ducts_insulated' in metadata &&
    'is_envelope_professionaly_sealed' in metadata &&
    'is_ventilation_rated_flow_known' in metadata &&
    'whole_home_ventilation_rated_flow' in metadata &&
    'whole_home_ventilation_type' in metadata &&
    'cooling_system_type' in metadata &&
    'is_cooling_system_efficiency_known' in metadata &&
    'cooling_system_seer' in metadata &&
    'is_cooling_system_percent_floor_area_known' in metadata &&
    'cooling_system_percent_floor_area' in metadata &&
    'heating_system_fuel_and_type' in metadata &&
    'is_heating_system_efficiency_known' in metadata &&
    'heating_system_hspf' in metadata &&
    'heating_system_afue' in metadata &&
    'heating_system_percent_floor_area' in metadata &&
    'upgrades_include_electrical_panel' in metadata &&
    'existing_panel_max_amps' in metadata &&
    'existing_panel_breaker_slots' in metadata &&
    'new_panel_max_amps' in metadata &&
    'new_panel_breaker_slots' in metadata &&
    'new_panel_material_costs' in metadata &&
    'new_panel_install_costs' in metadata &&
    'new_panel_total_costs' in metadata &&
    'electric_panel_attachment' in metadata &&
    'upgrades_include_electrical_wiring' in metadata &&
    'electrical_wiring_material_costs' in metadata &&
    'electrical_wiring_install_costs' in metadata &&
    'electrical_wiring_total_costs' in metadata &&
    'electrical_wiring_attachment' in metadata &&
    'heat_pump_ahri_certs' in metadata &&
    'water_heater_energy_star_certs' in metadata &&
    'fuel_switching_calculator' in metadata &&
    'manual_j_report' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataWIHEARType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataWIHEARType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'homeowner_type' in metadata &&
    'company_name' in metadata &&
    'customer_phone' in metadata &&
    'customer_email' in metadata &&
    'electric_provider' in metadata &&
    'electric_account_number' in metadata &&
    'is_natural_gas_primary_heating_source' in metadata &&
    'existing_heating_fuel_type' in metadata &&
    'gas_provider' in metadata &&
    'gas_account_number' in metadata &&
    'how_applicant_hear_about_program' in metadata &&
    'payee_name' in metadata &&
    'payee_address' in metadata &&
    'payee_city' in metadata &&
    'payee_state' in metadata &&
    'payee_zip' in metadata &&
    'building_type' in metadata &&
    'number_of_bedrooms' in metadata &&
    'contract_signed_date' in metadata &&
    'rebate_selection' in metadata &&
    'signed_project_contract_and_utility_bill_impact' in metadata &&
    'low_income_tenant_building_owner_acknowledgment' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadataSunrunType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadataSunrunType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_first_name' in metadata &&
    'customer_last_name' in metadata &&
    'customer_location' in metadata &&
    'sunrun_service_contract_id' in metadata &&
    'sunrun_opportunity_id' in metadata &&
    'sunrun_rebate_amount' in metadata &&
    'removed_services' in metadata &&
    'heat_pump_equipment' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSubmitForPreApprovalMetadata3CRENType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitForPreapprovalMetadata3CRENType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'customer_phone' in metadata &&
    'customer_email' in metadata &&
    'has_gas_utility' in metadata &&
    'has_electric_utility' in metadata &&
    'gas_bills' in metadata &&
    'gas_provider' in metadata &&
    'gas_said' in metadata &&
    'electric_bills' in metadata &&
    'electric_provider' in metadata &&
    'electric_said' in metadata &&
    'savings_estimate' in metadata &&
    'hard_to_reach_info' in metadata &&
    'estimated_install_start_date' in metadata &&
    'estimated_install_completion_date' in metadata &&
    'utility_rate_program' in metadata &&
    'primary_language' in metadata &&
    'native_american_nation' in metadata &&
    'electrification' in metadata &&
    'measures' in metadata &&
    'gas_identifier_type' in metadata &&
    'contractor_name' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isProvideWaterHeaterInstalledDetailsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ProvideWaterHeaterInstalledDetailsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'valid_energy_star_water_heater_types' in metadata;
};

export const isResolveSubmitTasksMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ResolveSubmitTasksMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'unresolved_tasks' in metadata;
};

export const isSubmitJobForEnrollmentMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollmentMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'site_address' in metadata &&
    'contractor_name' in metadata &&
    'contractor_address' in metadata &&
    'contractor_county' in metadata &&
    'is_mobile_manufactured_home' in metadata &&
    'attachments' in metadata &&
    'install_start_date' in metadata &&
    'install_completion_date' in metadata &&
    'electric_project_cost' in metadata &&
    'gas_project_cost' in metadata &&
    'total_project_cost' in metadata &&
    'customer_cost' in metadata &&
    'homeowner' in metadata &&
    'electric_provider' in metadata &&
    'electric_said' in metadata &&
    'gas_provider' in metadata &&
    'gas_said' in metadata &&
    'is_income_qualified' in metadata &&
    'measures_data' in metadata &&
    'total_energy_savings_kwh' in metadata &&
    'total_energy_savings_therms' in metadata &&
    'measure_cost' in metadata
  );
};

export const isSubmitJobForEnrollmentCOXcelMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollmentCOXcelMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'attachments' in metadata &&
    'state' in metadata &&
    'customer_type' in metadata &&
    'customer_or_trade_partner' in metadata &&
    'equipment_group' in metadata &&
    'product' in metadata &&
    'trade_partner_id' in metadata
  );
};

export const isSubmitJobForEnrollmentCATECHWHMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollmentCATECHWHMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'name' in metadata &&
    'email' in metadata &&
    'phone_number' in metadata &&
    'attachments' in metadata &&
    'site_details' in metadata &&
    'installation_county' in metadata &&
    'facility_type' in metadata &&
    'tcs_signed_date' in metadata &&
    'invoice_total' in metadata &&
    'invoice_material' in metadata &&
    'permit_number' in metadata &&
    'installation_start_date' in metadata &&
    'installation_end_date' in metadata &&
    'seeking_heehra_rebate' in metadata &&
    'incentive_passed_through_customer' in metadata &&
    'has_solar' in metadata &&
    'customer_opted_to_donate_usage_data_in_advance' in metadata &&
    'additional_incentives' in metadata &&
    'water_heaters_installed' in metadata
  );
};

export const isSubmitJobForEnrollmentSunrunMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollmentSunrunMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'attachments' in metadata &&
    'install_start_date' in metadata &&
    'install_completion_date' in metadata
  );
};

export const isSubmitJobForEnrollment3CEMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollment3CEMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'attachments' in metadata;
};

export const isGenericAttachmentsMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is GenericAttachmentsMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'attachments' in metadata;
};

export const isUpdateFuelSwitchingCalculatorMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is UpdateFuelSwitchingCalculatorMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'homeowner' in metadata &&
    'site_address' in metadata &&
    'contractor_name' in metadata &&
    'contractor_company' in metadata &&
    'location' in metadata &&
    'existing_heating_system' in metadata &&
    'utility_rates' in metadata &&
    'heat_pump_type' in metadata &&
    'average_annual_heating_fuel_consupmtion' in metadata
  );
};

export const isSubmitJobForEnrollmentWIHEARMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is SubmitJobForEnrollmentWIHEARMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'combustion_appliances_left_at_test_out' in metadata &&
    'venting_test_result' in metadata &&
    'spillage_test_result' in metadata &&
    'gas_leak_test_result' in metadata &&
    'ambient_co_test_result' in metadata &&
    'undiluted_co_test_result' in metadata &&
    'signs_of_mold' in metadata &&
    'roof_condition' in metadata &&
    'drainage_system_condition' in metadata &&
    'has_ashrae_calculations' in metadata &&
    'answers_disclosed_to_homeowner' in metadata &&
    'installation_date' in metadata &&
    'final_invoice_project_cost' in metadata &&
    'attachments' in metadata
  );
};

export const isApplyForIncomeVerificationMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ApplyForIncomeVerificationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if (
    'income_verification_support_url_caheehra' in metadata &&
    'income_documentation_support_url_caheehra' in metadata &&
    'income_verification_express_url_caheehra' in metadata &&
    'income_documentation_express_url_caheehra' in metadata &&
    'income_verification_comparison_documentation_url_caheehra' in metadata &&
    'contractor_email' in metadata
  ) {
    return true;
  } else {
    return false;
  }
};

export const isReviewPreHomeSafetyAssessmentMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewPreHomeSafetyAssessmentMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'address' in metadata && 'site_details' in metadata;
};

export const isMechanicalVentilationMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is MechanicalVentilationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'square_footage' in metadata && 'number_of_bedrooms' in metadata;
};

export const isStartIncomeQualificationMetadataGAHEARType = (
  metadata: TaskResponseType['metadata']
): metadata is StartIncomeQualificationMetadataGAHEARType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return (
    'project_home_address' in metadata &&
    'contractor_performing_work' in metadata &&
    'contractor_first_name' in metadata &&
    'contractor_last_name' in metadata &&
    'contractor_phone_number' in metadata &&
    'contractor_email' in metadata &&
    'new_or_existing_construction' in metadata &&
    'building_type' in metadata &&
    'building_single_family_details' in metadata &&
    'number_of_bedrooms' in metadata &&
    'is_building_rented' in metadata &&
    'conditioned_square_footage' in metadata &&
    'homeowner_first_name' in metadata &&
    'homeowner_last_name' in metadata &&
    'homeowner_email' in metadata &&
    'homeowner_phone' in metadata &&
    'homeowner_address' in metadata
  );
};

export const isApprovePaymentMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ApprovePaymentMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('invoice_attachments' in metadata && 'program_key' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isReviewScopeOfWorkMetadata = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewIncomeQualificationMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('scope_of_works' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isReviewFinalInvoiceMetadata = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewFinalInvoiceMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('final_invoices' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isReviewPermitTaskMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewPermitMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  if ('permits' in metadata) {
    return true;
  } else {
    return false;
  }
};

export const isReviewUploadedCommissioningFormMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ReviewUploadedCommissioningFormMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'attachments' in metadata;
};

export const isConfirmManualJReportMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ConfirmManualJReportMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'certificates_and_reports' in metadata;
};

export const isConfirmInstalledHeatPumpMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ConfirmInstalledHeatPumpMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'heat_pumps' in metadata;
};

export const isReviewInstalledHeatPumpMetadataType = (
  metadata: TaskResponseType['metadata']
): metadata is ConfirmInstalledHeatPumpMetadataType => {
  if (metadata === null || metadata === undefined) {
    return false;
  }
  return 'heat_pumps' in metadata && 'attachments' in metadata;
};
